import { render, staticRenderFns } from "./ViewStock.vue?vue&type=template&id=0fdbe8ec&"
import script from "./ViewStock.vue?vue&type=script&lang=js&"
export * from "./ViewStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports